import {
    CompanySettingsService
  } from "@/common/api.service"
  import {
    FETCH_USER_REGISTRATION_STATUS,
    SAVE_USER_REGISTRATION_STATUS,
    SAVE_UPDATE_INBOX_SETTINGS,
    CLEAR_INBOX_SETTINGS,
    RESET_STATE,
    FETCH_INBOX_SETTINGS,
    FETCH_COMPANY_SETTINGS,
    UPDATE_COMPANY_SETTINGS
  } from "./actions.type"
  import {
    SET_USER_REGISTRATION_STATUS,
    SET_ERROR,
    SET_INBOX_SETTINGS,
    SET_COMPANY_SETTINGS,
    STATE_RESET,
  } from "./mutations.type"
  const initialState = () => {
    return {
      allowregistration: false,
      companysettingerrors: [],
      inboxsettings: [],
    }
  };
  
  let state = initialState()

  const getters = {
    allowregistration(state) {
      return state.allowregistration
    },  
    inboxsettings(state) {
      return state.inboxsettings
    },
    companysettings(state){
      return state.companysettings
    }
  }

  const actions = {
    async [FETCH_USER_REGISTRATION_STATUS](context, slug) {
      const {
        data
      } = await CompanySettingsService.get(slug);
      context.commit(SET_USER_REGISTRATION_STATUS, data.data);
      return data;
    },
    async [FETCH_COMPANY_SETTINGS](context, slug) {
      const {
        data
      } = await CompanySettingsService.get(slug);
      context.commit(SET_COMPANY_SETTINGS, data.data);
      return data;
    },
    async [UPDATE_COMPANY_SETTINGS]  (context,data){
      return CompanySettingsService.post(data, 'profile')
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    async [FETCH_INBOX_SETTINGS](context, slug) {
      const {
        data
      } = await CompanySettingsService.get(slug);
      context.commit(SET_INBOX_SETTINGS, data.data);
      return data;
    },

    async [SAVE_USER_REGISTRATION_STATUS]  (context,data){
      return CompanySettingsService.post(data,'user')
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    async [SAVE_UPDATE_INBOX_SETTINGS]  (context,data){
      return CompanySettingsService.post(data,'inbox')
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    async [CLEAR_INBOX_SETTINGS]  (context){
      return CompanySettingsService.delete('inbox')
      .then(({ data }) => {
        context.commit(SET_INBOX_SETTINGS, {})
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },

    [RESET_STATE]({
        commit
      }) {
        commit(STATE_RESET);
      }    
 }

 const mutations = {
    [SET_USER_REGISTRATION_STATUS](state, userregistrationdata) {
        state.allowregistration =   userregistrationdata.allow_registration
    },
    [SET_INBOX_SETTINGS](state, inboxsettings) {
      state.inboxsettings =   inboxsettings
    },
    [SET_COMPANY_SETTINGS](state, companysettingsdata) {
      state.companysettings =   companysettingsdata
    },

    [SET_ERROR](state, error) {
      state.companysettingerrors = error;
    },    
    [STATE_RESET](state) {
      Object.assign(state, initialState())
    }
  };

  export default {
    state,
    getters,
    actions,
    mutations
  };
  